import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import ChirpyWebLg from '../../assets/icons/ChirpyWebLogoFull.svg';
import ChirpyWebSm from '../../assets/icons/ChirpyWebLogoShort.svg';  
import { useAppContext } from '../../appProvider/contextProvider';
import HamburgerMenuConstants from '../../constants/HamburgerMenuConstants';
import PremiumLock from '../PremiumFeatures/PremiumLock';

const HamburgerMenu = ({setMenuCollapsed,
  menuCollapsed,
  setMenuToggled,
  setPathToNavigate
}) => {
  
  const history = useHistory(); 

  const location = useLocation();

  const { selectedWebsite, isDirty, setDiscardPromptOpen, isFeatureAvailable } = useAppContext();

  const [activeMenu, setActiveMenu] = useState(null);
  const [openDropDowns, setOpenDropDowns] = useState([]);

  const [pathname, setPathname] = useState(location.pathname);

  history.listen(({pathname}) => {
    
    setActiveMenu(null);
    setPathname(pathname);
  })

  const accordionHandler = (index) => {
    const temp = [...openDropDowns];
    const isCurrentOpen = temp.indexOf(index);
    if(isCurrentOpen >= 0) {
        temp.splice(isCurrentOpen, 1);
    } else {
        temp.push(index);
    }
    setOpenDropDowns(temp);
  }

  const onMenuClick = (menu, index) => {
    if(menu.subMenu) {
      accordionHandler(index);
    } else {
      if(isDirty) {
        setDiscardPromptOpen(true);
        setPathToNavigate(menu.path);
      } else {
        setActiveMenu(index);
        history.push(menu.path);
        setMenuToggled(false); 
      }
    }
  }

  const onCollapsedClicked = () => {
    setOpenDropDowns([]);
    setMenuCollapsed(!menuCollapsed);
  }
  
  const hasMenuAccess = (subMenu) => {
    if(subMenu.useType && !subMenu.useType.includes(selectedWebsite?.user_type)) {
      return false;
    }
    if(subMenu.title === 'WooCommerce') {
        return selectedWebsite?.has_woo_commerce
    }
    if(subMenu.title === 'Shopify Automation') {
      return selectedWebsite?.has_shopify;
    }
    if(subMenu.user_type) {
      return subMenu.user_type.includes(selectedWebsite?.user_type) && subMenu.roles.includes(selectedWebsite?.role);
    }
    return subMenu.roles.includes(selectedWebsite?.role);
  }

  const isMenuActive = (path, nestedRoutes) => {
    if(pathname.includes(path)) return true
    if(nestedRoutes) {
      return nestedRoutes.includes(pathname);
    }
    return false;
  }

  const isAccOpen = (index, subMenu) => {
    return openDropDowns.includes(index) || (subMenu && subMenu.find(({path}) => pathname.includes(path)));
  }
  
  return <aside className="d-flex flex-column full-height">
  <button onClick = {() => onCollapsedClicked()} className="btn toggle-btn-rounded d-none d-lg-block">
      <i className={menuCollapsed ? 'icon icon-chevron-right' : 'icon icon-chevron-left'}></i>
  </button>
  <button onClick={() => setMenuToggled(false)} className="btn btn-neutral close-btn d-block d-md-none">
      <i className="icon icon-close icon-2x"></i>
  </button>
  <a className="logo-container-sm d-none d-md-block" onClick={() => history.push('/dashboard')} >
      <img src={ChirpyWebLg} alt="logo" className="logo-md"/>
      <img src={ChirpyWebSm} alt="logo" className="logo-sm"/>
  </a>
  <ul className="navigation-menu list-unstyled scrollable_y">
    {
      HamburgerMenuConstants.map((menu, index) => {
        const classes = [];
        if(isAccOpen(index, menu.subMenu) && !menuCollapsed) {
          classes.push('open-dropdown');
        }
        if(activeMenu === index || isMenuActive(menu.path)) {
          classes.push('active')
        }
        return hasMenuAccess(menu) && <li key={index} className={classes.join(' ') } >
            <a className="d-flex" onClick = {() => onMenuClick(menu, index)}>
                <i className={`icon ${menu.icon}`}></i> <span className='mr-2'>{menu.title}</span>
                {
                  (menu?.keyword && !isFeatureAvailable(menu.keyword)) && <PremiumLock isMenu />
                }
                {
                  menu.subMenu && <i 
                    onClick={() => accordionHandler(index)} 
                    className={isAccOpen(index, menu.subMenu)? 'icon icon-arrow-up sub-menu' : 'icon icon-arrow-down sub-menu'}>  
                  </i>
                }
            </a>
            {
              menu.subMenu && <div className="dropdown-menu">
                { 
                  menu.subMenu.map((subMenu, sub_index) => {
                    return hasMenuAccess(subMenu) &&  <a 
                      className = {activeMenu === `${index}_${sub_index}` || isMenuActive(subMenu.path, subMenu?.nestedRoutes) ? 'active d-flex' : 'd-flex'} 
                      onClick = {() => onMenuClick(subMenu, `${index}_${sub_index}`)} 
                      key={`${index}_${sub_index}`}
                      >
                        <span className='mr-2' >{subMenu.title}</span>
                        {(subMenu?.keyword && !isFeatureAvailable(subMenu.keyword)) && <PremiumLock isMenu />}
                      </a>
                  })
                }
              </div>
            }
            
        </li>
      })
    }
  </ul>
</aside>
}; 

export default HamburgerMenu;